// TODO Improve to get config file at runtime (from S3 for example)
import networksConfig from './networks-config.json'
export interface IChainConfig{
  chainId: number
  chainName: string
  rpcUrl: string
  explorerUrl: string
  backendUrl: string
  faucetUrl: string
  default: boolean
}

export const chains: IChainConfig[] = networksConfig
